export default function (valor) {
  if (valor === null) { return 0; }
  if (isNaN(valor)) { return valor; }
  return parseFloat(valor.toFixed(2)).toString().replace('.', ',');
}
